/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



console.log("working")

function hideSpinner() {
      document.getElementById("loading-spinner").style.display = "none";
    }

function generate_pdf() {
  document.getElementById('loading-spinner').style.display = 'block';
  document.getElementById('print-content').style.display = 'block';

  let fecha = new Date();
  let fechaFormateada =
        ('0' + fecha.getDate()).slice(-2) +
        ('0' + (fecha.getMonth() + 1)).slice(-2) +
        fecha.getFullYear() +
        ('0' + fecha.getHours()).slice(-2) +
        ('0' + fecha.getMinutes()).slice(-2);

  const $elementoParaConvertir = document.getElementById('print-content');
  html2pdf()
    .set({
        margin: 0,
        filename: "cotizacion_" + fechaFormateada + '.pdf',
        image: {
            type: 'jpeg',
            quality: 0.98
        },
        html2canvas: {
            scale: 5, // A mayor escala, mejores gráficos, pero más peso
            letterRendering: true,
        },
        jsPDF: {
            unit: "in",
            format: "letter",
            orientation: 'portrait' // landscape o portrait
        }
    })
    .from($elementoParaConvertir)
    .save()
    .catch(err => console.log(err))
    .then(() => {
      document.getElementById('print-content').style.display = 'none';
      hideSpinner();
    });
    
}